<div style="margin:0px;">
    <app-vwsa-text weight="bold" text="Customise Your New Plan"></app-vwsa-text><br />
    <app-vwsa-text weight="normal" text="Please select Plan Type, Years and Distance:">
    </app-vwsa-text><br />

    <div class="column__list">
        <div class="card__list">
            <app-vwsa-select inputId="customize-plan-type-select" label="Plan Type" [options]="planTypeOptions" [(value)]="selectedPlanType"
                (valueChange)="onPlanTypeSelected($event)" isRequired="true">
            </app-vwsa-select>
        </div>
        <div class="card__list">
            <app-vwsa-select inputId="customize-plan-years-select" label="Years" [options]="yearsOptions" [(value)]="selectedYears" (valueChange)="onYearsSelected()"
                isRequired="true">
            </app-vwsa-select>
        </div>
        <div class="card__list">
            <app-vwsa-select inputId="customize-plan-distance-select" label="Distance" [options]="distanceOptions" [(value)]="selectedDistance" (valueChange)="onDistanceSelected()"
                isRequired="true">
            </app-vwsa-select>
        </div>
    </div>

    <app-vwsa-text appearance="copy0100" text="* Indicates required fields"></app-vwsa-text>

    <div *ngIf="customizedPlan">
        <br />
        <div class="column__list">
            <div class="card__list">
                <app-new-plan-option [data]="customizedPlan"></app-new-plan-option>
            </div>
            <div class="card__list">
            </div>
            <div class="card__list">
            </div>
        </div>
    </div>
</div>